import { render, staticRenderFns } from "./WholeSaleBox.vue?vue&type=template&id=0f7ad40a&"
import script from "./WholeSaleBox.vue?vue&type=script&lang=js&"
export * from "./WholeSaleBox.vue?vue&type=script&lang=js&"
import style0 from "./WholeSaleBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports